import { Property as IgnitionProperty } from '@square/ignition';
import { Box } from '@squareup/dex-ui-shared-base';
import clsx from 'clsx';
import React, { FunctionComponent } from 'react';

import { PropertyContent } from '../../PropertyContent';
import { PropertyCategory, PropertyInfo } from '../../PropertyInfo';

import styles from './property-row.module.css';

interface PropertyRowProps {
  readonly category: PropertyCategory;
  readonly compact?: boolean;
  readonly disableAnchors?: boolean | undefined;
  readonly property: IgnitionProperty;
  readonly narrowView?: boolean;
  readonly showBottomBorder?: boolean;
}

/**
 */
const PropertyRow: FunctionComponent<PropertyRowProps> = ({
  category,
  compact = false,
  disableAnchors = false,
  property,
  narrowView = false,
  showBottomBorder = false,
}) => {
  const className = clsx(
    styles['property-row'],
    compact || narrowView ? styles['one-column'] : styles['two-column']
  );

  return (
    <Box
      margin={narrowView ? { top: '2x' } : { top: '4x' }}
      padding={showBottomBorder ? { bottom: '2x' } : undefined}
      border={showBottomBorder ? { line: { bottom: '20' } } : undefined}
      className={className}
    >
      <PropertyInfo
        category={category}
        disableAnchor={disableAnchors}
        property={property}
        narrowView={narrowView}
      />
      <PropertyContent
        property={property}
        narrowView={narrowView}
      ></PropertyContent>
    </Box>
  );
};

export { PropertyRow };
export { PropertyCategory } from '../../PropertyInfo';
